<template>
  <div
    ref="container"
    :class="classes"
    :style="style"
  >
    <div
      ref="left"
      class="_left"
    >
      <slot name="left" />
    </div>
    <div
      ref="right"
      class="_right"
    >
      <slot name="right" />
    </div>
  </div>
  <m-divider
    v-if="divider"
    small
  />
</template>

<script>
export default {
  name: 'ListHeader',
  props: {
    class: {
      type: String,
      default: '',
    },
    style: {
      type: Object,
      default: () => {},
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tight'],
  data() {
    return {
      tooTight: false,
      tightWidth: 0,
    };
  },
  computed: {
    classes() {
      return [this.class, 'list-header'];
    },
  },
  watch: {
    tooTight(val, oldVal) {
      if (val === oldVal) {
        return;
      }
      this.$emit('tight', this.tooTight);
    },
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      const containerWidth = this.$refs.container.getBoundingClientRect().width;
      const leftWidth = this.$refs.left.getBoundingClientRect().width;
      const rightWidth = this.$refs.right.getBoundingClientRect().width;
      if (!this.tooTight) {
        this.tightWidth = leftWidth + rightWidth;
      }
      if (containerWidth < this.tightWidth) {
        this.tooTight = true;
        return;
      }
      this.tooTight = false;
    });
    this.resizeObserver.observe(this.$refs.container);
  },
  unmounted() {
    this.resizeObserver.disconnect();
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .list-header {
    display: flex;

    ._right {
      display: flex;
      margin-left: auto;
    }

    ._left {
      display: flex;
      align-items: center;
    }
  }
</style>
